export function toTitleCase(str) {
  const titleCase = str
    ?.toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0)?.toUpperCase() + word?.slice(1);
    })
    .join(" ");

  return titleCase;
}

export function toUpperCaseFirst(str) {
  const titleCase = str?.charAt(0).toUpperCase() + str?.slice(1);

  return titleCase;
}

export function toUpperCase(str) {
  const upperCase = str?.toUpperCase();

  return upperCase;
}

export function toLowerCase(str) {
  const lowerCase = str?.toLowerCase();

  return lowerCase;
}

export function processParagraph(paragraph) {
  const words = paragraph.split(" "); // Split the paragraph into words
  if (words.length > 1) {
    return toTitleCase(words.slice(1).join(" ")); // Remove the first word and join the rest
  }
  return toTitleCase(paragraph); // Return as is if there's only one word
}

export function smartTitleCase(text) {
  if (!text) return "";

  const lowerWords = [
    "of",
    "is",
    "and",
    "when",
    "under",
    "the",
    "to",
    "for",
    "in",
    "on",
    "with",
    "at",
    "by",
  ];

  const vowelRegex = /[aeiou]/i;
  const romanRegex = /^(i|ii|iii|iv|v|vi|vii|viii|ix|x)$/i;

  let result = text
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      if (lowerWords.includes(word) && index !== 0) {
        return word;
      }

      if (romanRegex.test(word)) {
        return word.toUpperCase();
      }

      if (!vowelRegex.test(word)) {
        return word.toUpperCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");

  result = result.replace(/\(([^)]+)\)/g, (_, content) => {
    return `(${content.toUpperCase()})`;
  });

  return result;
}
